<template>
  <div id="mainContainer">
    <!-- <div class=""> -->
    <div id="contentWrapper" class>
      <div id="logo" class>
        <img src="~@/assets/images/main_logo.png" />
      </div>
      <!-- <div class="banner">This is a banner!</div> -->
      <span v-if="prize.couponCode != false">
        <p id="prizeHeader">YOUR UNIQUE DISCOUNT CODE:</p>
        <p id="prizeContainer">{{ prize.couponCode }}</p>
      </span>
      <p id="noMoreCodesTxt" v-else>HOPE YOU SAVED ROOM FOR SECONDS</p>

      <div id="bottomWrapper">
        <p v-if="prize.couponCode != false" class="instructions txt">
          Hey there. Worked up an appetite? This offer is just for you then. Use
          the code above during checkout to take $5 off your next order of $20
          or more.
        </p>
        <p
          v-else
          class="instructions txt"
        >Don't play games with your appetite. Get exactly what you're craving, delivered to your door.</p>
        <div id="orderNowBtn" @click="handleOrderNow">
          <img src="~@/assets/images/order_now_btn.png" />
        </div>
        <p v-if="prize.couponCode != false" id="legalTxt">
          Valid on delivery orders of $20 or more before taxes, tips, and
          delivery fees. Not valid on orders containing alcohol. Cannot be
          combined with other offers. Limit 1 use per customer. Voidable without
          notice. Expires June 23, 11:59pm CT.
        </p>
      </div>
    </div>
    <!-- bottom wrapper -->
  </div>
</template>

<script>
// import PrizeService from "@/services/PrizeService.js";
// import { mapState } from "vuex";
import store from "@/store/index.js";

function getPrize(routeTo, next) {
  // store.dispatch("getPrize").then(() => {
  //   // console.log(result);
  //   next();
  // });

  next();
}

function createFunctionWithTimeout(callback, opt_timeout) {
  var called = false;
  function fn() {
    if (!called) {
      called = true;
      callback();
    }
  }
  setTimeout(fn, opt_timeout || 1000);
  return fn;
}

// function goToMainSite() {
//   window.location = "https://www.skipthedishes.com/";
// }

export default {
  beforeRouteEnter(routeTo, routeFrom, next) {
    getPrize(routeTo, next);
  },
  methods: {
    handleLegalBtnClicked() {
      store.dispatch("general/setLegalVisible", true, { root: true });
    },
    handleOrderNow() {
      // console.log("handleOrderNow()")

      let hasCodeURL =
        " https://www.skipthedishes.com/?utm_source=skipthedishes-stg.avatarclient.net&utm_medium=referral&utm_campaign=gta_lens&utm_content=code_redeemed";

      let noCodeURL =
        "https://www.skipthedishes.com/?utm_source=skipthedishes-stg.avatarclient.net&utm_medium=referral&utm_campaign=gta_lens&utm_content=no_code";

      let exitURL = this.prize.couponCode !== false ? hasCodeURL : noCodeURL;
      let hasCodeLabel =
        this.prize.couponCode !== false ? "code_true" : "code_false";

      try {
        window.gtag("event", "order_now", {
          event_category: "btn_click",
          event_label: hasCodeLabel,
          event_callback: createFunctionWithTimeout(() => {
            // console.log("now that event is recoreded lets go to site");
            // goToMainSite();
            window.location = exitURL;
          })
        });
      } catch (e) {
        // console.log(e);
        // there was a problem, lets just go to site
        // goToMainSite();
        window.location = exitURL;
      }
      //TODO. set url link, record in analytics first
      //https://www.skipthedishes.com/
    }
  },
  computed: {
    prize() {
      return { status: 200, couponCode: false };
    },
    legalVisible() {
      return this.$store.state.general.legalVisible;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/home.scss";
</style>

